/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2020-04-13
 * @description Implementation of the GraphQL mutation to add a user history.
 * @filename create-user-history.ts
 */

import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL mutation to add an podcast.
 *
 * @type {GraphQLTaggedNode}
 */
export const CREATE_USER_HISTORY_GRAPHQL_MUTATION: GraphQLTaggedNode = graphql`
  mutation createUserHistoryMutation($input: CreateUserHistoryInput!) {
    createUserHistory(input: $input) {
      clientMutationId
      hasErrors
      errors {
        id
        location
      }
      userHistory
    }
  }
`;
